import React from "react";
import CompanyForm from "../../components/company/CompanyForm";

/** Pozostawia użytkownika w ustawieniach i odświeża formularz po zapisie nowej wersji. */
export default function EditCompanyPage({ company, options, token, onSaved }) {
  return (
    <CompanyForm
      key={company.version}
      company={company}
      options={options}
      token={token}
      onSaved={onSaved}
    />
  );
}
